export const isValidChia = (addr: string) => {
  if (!addr) return false;
  const a = addr.trim().toLowerCase();
  return /^(xch|txch)1[0-9a-z]{30,80}$/.test(a);
};

export const isValidFilecoin = (addr: string) => {
  if (!addr) return false;
  const a = addr.trim();
  if (/^[ft]0[0-9]+$/.test(a)) return true;
  return /^[ft](1|3|4)[0-9a-z]{30,80}$/.test(a);
};

export const isValidArweave = (addr: string) => {
  if (!addr) return false;
  const value = addr.trim();
  return /^[A-Za-z0-9_-]{43}$/.test(value) && new Set(value).size >= 10;
};
